import React from 'react';
import { styled } from 'styled-components';

export interface IGroup extends React.PropsWithChildren {
  className?: string;
}

const Group = styled.div<IGroup>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: -2px;
  > * {
    margin: 2px;
  }
`;

export const Wrapper = styled.span<{ $bgColor?: string; onClick?: () => void; $nowrap?: boolean }>`
  display: inline-flex;
  padding: 5px;
  min-width: 42px;
  font-size: 10px;
  line-height: 1;
  font-weight: 500;
  justify-content: center;
  color: ${({ $bgColor, theme }) => ($bgColor ? theme.colors.grey00_2 : theme.colors.black_1)};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  background-color: ${({ $bgColor, theme }) => $bgColor || theme.colors.grey00_1};
  cursor: ${({ onClick }) => !!onClick && 'pointer'};
  white-space: ${({ $nowrap }) => $nowrap && 'nowrap'};
`;

export interface ITag {
  color?: string;
  className?: string;
  value: React.ReactNode;
  onClick?: () => void;
  $nowrap?: boolean;
  dataTestId?: string;
}

const Tag: React.FC<ITag> = ({ color, className, value, onClick, $nowrap, dataTestId }) => (
  <Wrapper className={className} $bgColor={color} onClick={onClick} $nowrap={$nowrap} data-testid={dataTestId}>
    {value}
  </Wrapper>
);

export type TagFC<P = Record<string, never>> = React.FC<P> & {
  Group: React.FC<IGroup>;
};

const TagMemo = React.memo(Tag);

const TagWrapper: TagFC<ITag> = (props, dataTestId) => <TagMemo {...props} data-testid={dataTestId} />;

TagWrapper.Group = Group;

export default TagWrapper;
